module.exports = __webpack_public_path__ + "07e28ffc94413cea9eceddb5ec87b175.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/tooie.png
// module id = 447
// module chunks = 0